var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavVRegistro = function SvgNavVRegistro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nav_v_registro_svg__Capa_2",
    viewBox: "0 0 33.67 33.67"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_v_registro_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.74.75C5.22.75.75 5.22.75 10.74M32.92 10.74c0-5.52-4.47-9.99-9.99-9.99M22.94 32.92c5.52 0 9.99-4.47 9.99-9.99M.75 22.94c0 5.52 4.47 9.99 9.99 9.99",
    stroke: "#b3b3b3",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: "1.5px"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.65,
    cy: 16.78,
    r: 8.7,
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: "1.5px",
    stroke: "#19d3c5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.65,
    cy: 16.78,
    r: 3.26,
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: "1.5px",
    stroke: "#19d3c5"
  }))));
};
export default SvgNavVRegistro;